import * as XLSX from "xlsx";
import { calcSection } from "./timeUtils";
import { appendRemark } from "./entryUtils";
import { OUTCOME_REMARKS } from "./constants";

// Airport coordinates [lat, lon] — used to pick the closest dest when merging thru-flight rows
const AIRPORT_COORDS = {
  LAX: [33.9425, -118.4081],
  // Asia-Pacific
  HKG: [22.3080,  113.9185], SGN: [10.8188,  106.6520], NRT: [35.7647,  140.3864],
  HND: [35.5494,  139.7798], ICN: [37.4692,  126.4505], PEK: [40.0799,  116.6031],
  PKX: [39.5091,  116.4100], PVG: [31.1443,  121.8083], SHA: [31.1681,  121.3362],
  CAN: [23.3959,  113.3080], SIN: [1.3644,   103.9915], BKK: [13.6811,  100.7472],
  KUL: [2.7456,   101.7072], MNL: [14.5086,  121.0194], SYD: [-33.9399, 151.1753],
  MEL: [-37.6690, 144.8410], BNE: [-27.3842, 153.1175], PER: [-31.9403, 115.9669],
  AKL: [-37.0082, 174.7917], CHC: [-43.4894, 172.5322], TPE: [25.0777,  121.2328],
  CGK: [-6.1275,  106.6537], DPS: [-8.7487,  115.1671], SUB: [-7.3798,  112.7870],
  DEL: [28.5562,   77.1000], BOM: [19.0887,   72.8679], MAA: [12.9941,   80.1709],
  CCU: [22.6547,   88.4467], HYD: [17.2403,   78.4294],
  // Middle East
  DXB: [25.2532,   55.3657], DOH: [25.2609,   51.6138], AUH: [24.4330,   54.6511],
  KWI: [29.2267,   47.9689], BAH: [26.2708,   50.6336], AMM: [31.7226,   35.9932],
  CAI: [30.1219,   31.4056], BEY: [33.8209,   35.4883],
  // Europe
  LHR: [51.4775,   -0.4614], LGW: [51.1537,   -0.1821], CDG: [49.0097,    2.5479],
  FRA: [50.0379,    8.5622], AMS: [52.3086,    4.7639], MAD: [40.4936,   -3.5668],
  BCN: [41.2974,    2.0785], FCO: [41.8003,   12.2389], ZRH: [47.4582,    8.5555],
  VIE: [48.1102,   16.5697], MUC: [48.3538,   11.7861], ARN: [59.6519,   17.9186],
  CPH: [55.6180,   12.6508], HEL: [60.3172,   24.9633], OSL: [60.1939,   11.1004],
  DUB: [53.4213,   -6.2701], MAN: [53.3537,   -2.2750], BRU: [50.9010,    4.4844],
  LIS: [38.7756,   -9.1354], ATH: [37.9364,   23.9475], IST: [41.2753,   28.7519],
  // US domestic
  SFO: [37.6213, -122.3790], SJC: [37.3626, -121.9291], OAK: [37.7213, -122.2208],
  SEA: [47.4502, -122.3088], PDX: [45.5898, -122.5951], LAS: [36.0840, -115.1537],
  PHX: [33.4373, -112.0078], DEN: [39.8561, -104.6737], SLC: [40.7884, -111.9778],
  DAL: [32.8473,  -96.8518], DFW: [32.8998,  -97.0403], IAH: [29.9902,  -95.3368],
  HOU: [29.6454,  -95.2789], MSP: [44.8848,  -93.2223], ORD: [41.9742,  -87.9073],
  MDW: [41.7868,  -87.7522], DTW: [42.2124,  -83.3534], MSO: [46.9163, -114.0906],
  BZN: [45.7776, -111.1530], GEG: [47.6199, -117.5338], BOI: [43.5644, -116.2228],
  RNO: [39.4991, -119.7681], SMF: [38.6954, -121.5908], BUR: [34.2007, -118.3587],
  LGB: [33.8177, -118.1516], ONT: [34.0560, -117.6010], SAN: [32.7336, -117.1897],
  SNA: [33.6757, -117.8682], PSP: [33.8297, -116.5067], SBA: [34.4262, -119.8406],
  FAT: [36.7762, -119.7182], MRY: [36.5870, -121.8430],
  ATL: [33.6367,  -84.4281], CLT: [35.2140,  -80.9431], MIA: [25.7959,  -80.2870],
  FLL: [26.0726,  -80.1527], MCO: [28.4294,  -81.3089], TPA: [27.9755,  -82.5332],
  PHL: [39.8719,  -75.2411], EWR: [40.6925,  -74.1687], JFK: [40.6413,  -73.7781],
  LGA: [40.7772,  -73.8726], BOS: [42.3656,  -71.0096], DCA: [38.8521,  -77.0377],
  IAD: [38.9531,  -77.4565], BWI: [39.1754,  -76.6682], RDU: [35.8776,  -78.7875],
  ORF: [36.8976,  -76.0183], BNA: [36.1263,  -86.6774], MEM: [35.0424,  -89.9767],
  STL: [38.7487,  -90.3700], MCI: [39.2976,  -94.7139], OMA: [41.3032,  -95.8940],
  MSY: [29.9934,  -90.2580], BHM: [33.5629,  -86.7535], JAX: [30.4941,  -81.6879],
  CLE: [41.4117,  -81.8498], CMH: [39.9980,  -82.8919], IND: [39.7173,  -86.2944],
  PIT: [40.4915,  -80.2329], BUF: [42.9405,  -78.7322], ALB: [42.7483,  -73.8020],
  SYR: [43.1112,  -76.1063], ROC: [43.1189,  -77.6724], PWM: [43.6462,  -70.3093],
  BDL: [41.9389,  -72.6832], PVD: [41.7244,  -71.4281], MHT: [42.9326,  -71.4357],
  OKC: [35.3931,  -97.6007], TUL: [36.1984,  -95.8881], ABQ: [35.0402, -106.6090],
  ELP: [31.8072, -106.3777], SAT: [29.5337,  -98.4698], AUS: [30.1975,  -97.6664],
  ANC: [61.1743, -149.9963], HNL: [21.3187, -157.9224], OGG: [20.8986, -156.4305],
  KOA: [19.7388, -156.0456], LIH: [21.9760, -159.3388], ITO: [19.7214, -155.0485],
  GUM: [13.4834,  144.7960], SPN: [15.1197,  145.7292],
  // Americas
  YYZ: [43.6777,  -79.6248], YVR: [49.1947, -123.1792], YUL: [45.4706,  -73.7408],
  YYC: [51.1313, -114.0100], MEX: [19.4363,  -99.0721], CUN: [21.0365,  -86.8771],
  GDL: [20.5218,  -103.3108], MTY: [25.7749,  -100.1071],
  GRU: [-23.4356, -46.4731], EZE: [-34.8222, -58.5358], BOG: [4.7016,   -74.1469],
  SCL: [-33.3930, -70.7858], LIM: [-12.0219, -77.1143], UIO: [-0.1292,  -78.3575],
  GIG: [-22.8099, -43.2505], BSB: [-15.8711, -47.9186], MDE: [6.1645,   -75.4233],
  PTY: [9.0714,   -79.3835], SJO: [9.9939,   -84.2088],
};

function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function distFromLax(iata) {
  const lax = AIRPORT_COORDS.LAX;
  const c = AIRPORT_COORDS[iata];
  if (!c) return Infinity;
  return haversineKm(lax[0], lax[1], c[0], c[1]);
}

// Outcome from TDT expedite-pax counts, or "" while any are still in progress.
// Goes to pendingStatus (the Pending tab) — an SCCO approves it into status.
function expediteOutcome(exp) {
  if (exp.inprog > 0) return "";
  if (exp.success && exp.failure) return "PARTIAL SUCCESS";
  if (exp.success) return "SUCCESS";
  if (exp.failure) return "UNSUCCESSFUL";
  return "";
}

// Mirrors parse_excel() in tdt-sync/ha-addon/tdt_sync.py — keep the two in step.
function parseExcelForImport(arrayBuffer, parsedShift) {
  const wb = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
  if (rows.length < 2) return [];

  // Columns are found by header name; the positions are the current TDT export layout,
  // used only if a header is missing. Gate appears twice (inbound, then outbound).
  const hdr = rows[0].map(h => String(h ?? "").trim().toLowerCase());
  const col = (name, fallback) => { const i = hdr.indexOf(name); return i >= 0 ? i : fallback; };
  const colLast = (name, fallback) => { const i = hdr.lastIndexOf(name); return i >= 0 ? i : fallback; };
  const C = {
    inFlt:   col("inbound flights", 0),
    origin:  col("origin", 1),
    sta:     col("sta", 2),
    eta:     col("eta", 3),
    ata:     col("ata", 4),
    inGate:  col("gate", 7),
    outFlt:  col("outbound flights", 9),
    dest:    col("destination", 10),
    outGate: colLast("gate", 11),
    std:     col("std", 13),
    etd:     col("etd", 14),
    atd:     col("atd", 15),
    pax:     col("passenger f|c|y", col("passenger", 17)),
    bags:    col("baggage", 18),
    status:  col("status", 19),
  };
  // Expedite-pax counts drive the monitoring flag and the Pending outcome. No positional
  // fallback: if TDT renames a column, that count reads as 0.
  const C_EXP = {
    inprog:  col("expedite pax inprogress", -1),
    success: col("expedite pax success", -1),
    failure: col("expedite pax failure", -1),
  };

  // Extract 2-letter carrier code from flight string e.g. "UA2434" → "UA", "SQ36" → "SQ"
  const extractCarrier = (flt) => {
    const m = String(flt || "").trim().match(/^([A-Z]{2,3})(?=\d)/i);
    return m ? m[1].toUpperCase() : "";
  };

  // Parse time cell: strip any trailing S/E suffix, return "HH:MM"
  const parseTimeCell = (val) => {
    if (!val && val !== 0) return "";
    const digits = String(val).trim().replace(/[^0-9]/g, "");
    if (digits.length < 3) return "";
    const padded = digits.padStart(4, "0");
    return padded.slice(0, 2) + ":" + padded.slice(2, 4);
  };

  // Parse F|C|Y passenger string → total integer
  const parsePax = (val) => {
    if (!val && val !== 0) return "";
    const s = String(val).trim();
    if (s.includes("|")) {
      const total = s.split("|").reduce((sum, p) => sum + (parseInt(p, 10) || 0), 0);
      return total > 0 ? String(total) : "";
    }
    const n = parseInt(s, 10);
    return (!isNaN(n) && n > 0) ? String(n) : "";
  };

  // Numeric count cell (TDT exports counts as floats, e.g. 2.0) → int, 0 if blank/invalid
  const parseCount = (val) => Math.trunc(Number(val)) || 0;

  const IMPORT_STATUSES = ["at risk", "unachievable", "cancelled"];
  const cell = (r, i) => (i >= 0 ? r[i] : "");
  const text = (r, i) => String(cell(r, i) ?? "").trim().toUpperCase();

  const rawEntries = [];
  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    if (!r || r.every(c => c === "")) continue;
    const statusCol = String(cell(r, C.status) ?? "").toLowerCase().trim();
    const expedite = Object.fromEntries(
      Object.entries(C_EXP).map(([k, c]) => [k, parseCount(cell(r, c))]));
    // Connections with any expedite activity are imported even when TDT calls them Achievable
    if (!IMPORT_STATUSES.includes(statusCol) && !Object.values(expedite).some(Boolean)) continue;

    const inFltRaw  = text(r, C.inFlt);
    const outFltRaw = text(r, C.outFlt);
    if (!inFltRaw && !outFltRaw) continue;

    const atdRaw = text(r, C.atd);
    const sta = parseTimeCell(cell(r, C.sta));
    const eta = parseTimeCell(cell(r, C.eta));
    const ata = parseTimeCell(cell(r, C.ata));
    const std = parseTimeCell(cell(r, C.std));
    const etd = parseTimeCell(cell(r, C.etd));
    const atd = atdRaw === "XCL" ? "XCL" : parseTimeCell(cell(r, C.atd));
    const bags = cell(r, C.bags);

    const inAirline  = extractCarrier(inFltRaw);
    const outAirline = extractCarrier(outFltRaw);

    rawEntries.push({
      airline:      inAirline || outAirline,
      inAirline,
      inFlt:        inFltRaw,
      origin:       text(r, C.origin).slice(0, 3),
      inGate:       text(r, C.inGate),
      sta, eta, ata,
      outAirline,
      outFlt:       outFltRaw,
      dest:         text(r, C.dest).slice(0, 3),
      outGate:      text(r, C.outGate),
      std, etd, atd,
      ttlPax:       parsePax(cell(r, C.pax)),
      ttlBags:      bags !== "" && !isNaN(Number(bags)) ? String(Math.round(Number(bags))) : "",
      paxExp: "", paxRbk: "", bagsExp: "",
      remark:       "",
      cancelled:    statusCol === "cancelled",
      status:       "",
      expedite,
      autoImported: true,
      section:      calcSection({ sta, eta, ata, std, etd, atd }, parsedShift),
    });
  }

  // Merge thru flights: same inFlt+outFlt with different dest values (e.g. UA152 stops at HKG
  // then SGN — two rows, same flight numbers). Combine pax/bags/expedite counts and keep the
  // dest closest to LAX (that's the first physical stop on the thru flight).
  const merged = [];
  const seenKey = new Map(); // matchKey → index in merged
  for (const entry of rawEntries) {
    const key = `${entry.inFlt}|${entry.outFlt}`;
    if (seenKey.has(key)) {
      const canonical = merged[seenKey.get(key)];
      const addPax  = parseInt(entry.ttlPax,  10) || 0;
      const addBags = parseInt(entry.ttlBags, 10) || 0;
      if (addPax  > 0) canonical.ttlPax  = String((parseInt(canonical.ttlPax,  10) || 0) + addPax);
      if (addBags > 0) canonical.ttlBags = String((parseInt(canonical.ttlBags, 10) || 0) + addBags);
      for (const k of Object.keys(canonical.expedite)) canonical.expedite[k] += entry.expedite[k];
      // Use the dest that is geographically closer to LAX — that's the first thru-flight stop
      if (distFromLax(entry.dest) < distFromLax(canonical.dest)) {
        canonical.dest    = entry.dest;
        canonical.outGate = entry.outGate;
        canonical.std     = entry.std;
        canonical.etd     = entry.etd;
        canonical.atd     = entry.atd;
      }
    } else {
      seenKey.set(key, merged.length);
      merged.push(entry);
    }
  }

  for (const e of merged) {
    e.monitoring    = Object.values(e.expedite).some(Boolean);
    e.pendingStatus = expediteOutcome(e.expedite);
    if (e.pendingStatus) {
      e.remark = appendRemark("", OUTCOME_REMARKS[e.pendingStatus], "TDT");
      // Pax expedited = passengers who made it (e.g. partial: 3 success + 1 failure → 3)
      e.paxExp = String(e.expedite.success);
    }
  }
  return merged;
}

export { parseExcelForImport };
